/* eslint-disable no-restricted-syntax */
import { useState } from 'react';

import { useSdgroupApiClient } from '../useSdgroupApiClient';
import { useServerParams } from "./useServerParams"

export function useMarking({ routeType }) {

    const { makeCall, serverClient } = useSdgroupApiClient();

    const [isLoading, setIsLoading] = useState(false)

    const {
        getListsUrl,
        // getUrlWithDataTypes, 
        _operatorDef: filterOperatorTypes
    } = useServerParams();

    const listMarkings = async ({
        props,
    }) => {

        setIsLoading(true);

        try {

            let filterValues = []

            // if (companyCode) {
            //     filterValues = [...filterValues, ...[
            //         {
            //             name: `CompanyCode`,
            //             operator: filterOperatorTypes.eq,
            //             value: companyCode,
            //         },
            //     ]]
            // }

            if (props?.filterValue) {
                props.filterValue = [...props.filterValue, ...filterValues]
            } else {
                props.filterValue = filterValues
            }

            let url = getListsUrl(`markings`, props);

            // console.log('props', props)

            const result = await makeCall({
                url,
                method: "GET",
                payload: {},
            });

            // console.log('response', response)

            setIsLoading(false);

            let data = result?.data?.Markings ? result.data.Markings : []

            return {
                data,
                count: result?.data?.total
            }

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        listMarkings
    }

}